import * as C from './styles';
import LogoGetap from '../../assets/png/getap.png';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { BiPowerOff, BiUser } from 'react-icons/bi';
import { useAuth } from '../../hooks/auth';
import { useAppStore } from '../../store';

export const Header = () => {
    const { signOut, user } = useAuth();
    const navigate = useNavigate();
    const clearSubscription = useAppStore((store) => store.clearSubscription);

    const handleProfileClick = () => {
        clearSubscription();
        navigate('/perfil');
    };

    return (
        <C.Header>
            <C.Logo>
                <img src={LogoGetap} alt="Getap" />
            </C.Logo>
            <ul>
                <li><NavLink to="/">Home</NavLink></li>
                <li><a href="https://getap.agr.br/quem-somos/">Quem somos</a></li>
                <li><a href="https://getap.agr.br/getap-milho/">Getap Milho</a></li>
                <li><a href="https://getap.agr.br/getap-sorgo/">Getap Sorgo</a></li>
                <li><a href="https://getap.agr.br/contato/">Contato</a></li>
            </ul>
            {!user ? <C.CtaSubscribe>
                <span>Participe do Getap</span>
                <button><Link to="/cadastro">INSCREVA-SE</Link></button>
            </C.CtaSubscribe> :
                <C.UserActions>
                    <C.ProfileButton onClick={handleProfileClick}>
                        <BiUser size={18} />
                    </C.ProfileButton>
                    <C.CtaLogout onClick={signOut}>
                        <BiPowerOff size={16} style={{
                            marginRight: '8px'
                        }} />
                        Sair
                    </C.CtaLogout>
                </C.UserActions>}
        </C.Header>
    )
}